import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';

import Utils from '../../../Services/Utils';

import withShallowComparison from '../../Common/withShallowComparisonUpdate';
import InputWrapper from '../WrapperInput';

import './style.scss';

class InputPhone extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) {
      return 'This field is required.';
    }
    for (const validator of validators || []) {
      if (validator(value)) {
        return validator(value);
      }
    }
    return '';
  };

  handleChange = (e) => {
    const { onChange, onError, error } = this.props;
    const value = e && e.target ? e.target.value : e;
    if (onChange) {
      onChange(value);
    }
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  render() {
    const { className, label, labelhtml, error, placeholder, disabled, required, value } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required
    };

    return (
      <InputWrapper {...WrapperProps}>
        <PhoneInput
          containerClass={'InputPhone'}
          disabled={disabled}
          placeholder={placeholder}
          required={required}
          onChange={this.handleChange}
          value={value}
          error={error}
        />
      </InputWrapper>
    );
  }
}

InputPhone.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validators: PropTypes.array,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func
};

export default withShallowComparison(InputPhone, ['onChange', 'onError']);
